<template>
  <div class="selected-offer">
    <Header></Header>
    <section id="default-page-template">
      <div class="coverPhoto" style="background-image: url(img/about-bg.jpg)">
        <div class="container">
          <div class="row align-items-center">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="header-title">
              <h2>
                Pako e selektuar është për
                <span>Kosovë</span>
              </h2>
            </div>
          </div>
        </div>
        </div> 
      </div>
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-12">
            <div class="packagetable">
              <table v-if="offerPlanType == 'seasonal'">
                <thead>
                  <tr>
                    <th>
                      <div class="form-group">
                        <span style="padding-right: 5px; padding-left: 7px;">Zgjedh oferten:</span>
                        <div class="styled-input-single p0">
                          <input
                            type="radio"
                            name="fieldset-3"
                            id="radio-example-five"
                            @click="getOfferPlanType('annual')"
                          >
                          <label for="radio-example-five" style="padding-right: 5px;">Vjetore</label>
                        </div>
                        <div class="styled-input-single">
                          <input type="radio" name="fieldset-3" id="radio-example-six" checked>
                          <label for="radio-example-six">sezonale</label>
                        </div>
                      </div>
                    </th>
                    <th :class="{ highlight: selectedPackage === 4 }">
                      <h5>kosova</h5>
                      <p>
                        <span>{{ calculatePackagePrice(4, offerPlanType, currentPromotion) }}€</span> / 60 ditë
                      </p>
                    </th>
                    <th :class="{ highlight: selectedPackage === 5 }">
                      <h5>Ballkani</h5>
                      <p>
                        <span>{{ calculatePackagePrice(5, offerPlanType, currentPromotion) }}€</span> / 60 ditë
                      </p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>
                      <p>{{ packageDescriptionContent[4].primary_content }}</p>
                    </th>
                    <th :class="{ 'item-checked': true, highlight: selectedPackage === 4 }"></th>
                    <th :class="{ 'item-checked': true, highlight: selectedPackage === 5 }"></th>
                  </tr>
                  <tr>
                    <th>
                      <p>{{ packageDescriptionContent[5].primary_content }}</p>
                    </th>
                    <th :class="{ highlight: selectedPackage === 4 }"></th>
                    <th :class="{ 'item-checked': true, highlight: selectedPackage === 5 }"></th>
                  </tr>
                  <tr>
                    <th></th>
                    <th>
                      <button @click="getSelectedPackageBeforeBilling(4)">blej</button>
                    </th>
                    <th>
                      <button @click="getSelectedPackageBeforeBilling(5)">blej</button>
                    </th>
                  </tr>
                </tbody>
              </table>
              <table v-if="offerPlanType == 'annual'">
                <thead>
                  <tr>
                    <th>
                      <div class="form-group">
                        <span style="padding-right: 5px; padding-left: 7px;">Zgjedh oferten:</span>
                        <div class="styled-input-single p0">
                          <input type="radio" name="fieldset-3" id="radio-example-five" checked>
                          <label for="radio-example-five" style="padding-right: 5px;">Vjetore</label>
                        </div>
                        <div class="styled-input-single">
                          <input
                            type="radio"
                            name="fieldset-3"
                            id="radio-example-six"
                            @click="getOfferPlanType('seasonal')"
                          >
                          <label for="radio-example-six">sezonale</label>
                        </div>
                      </div>
                    </th>
                    <th :class="{ highlight: selectedPackage === 4 }">
                      <h5>Kosova</h5>
                      <p>
                        <span>{{ calculatePackagePrice(4, offerPlanType, currentPromotion) }}€</span> / viti
                      </p>
                    </th>
                    <th :class="{ highlight: selectedPackage === 5 }">
                      <h5>Ballkani</h5>
                      <p>
                        <span>{{ calculatePackagePrice(5, offerPlanType, currentPromotion) }}€</span> / viti
                      </p>
                    </th>
                    <th :class="{ highlight: selectedPackage === 6 }">
                      <h5>Evropa</h5>
                      <p>
                        <span>{{ calculatePackagePrice(6, offerPlanType, currentPromotion) }}€</span> / viti
                      </p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>
                      <p>{{ packageDescriptionContent[4].primary_content }}</p>
                    </th>
                    <th :class="{ 'item-checked': true, highlight: selectedPackage === 4 }"></th>
                    <th :class="{ 'item-checked': true, highlight: selectedPackage === 5 }"></th>
                    <th :class="{ 'item-checked': true, highlight: selectedPackage === 6 }"></th>
                  </tr>
                  <tr>
                    <th>
                      <p>{{ packageDescriptionContent[5].primary_content }}</p>
                    </th>
                    <th :class="{ highlight: selectedPackage === 4 }"></th>
                    <th :class="{ 'item-checked': true, highlight: selectedPackage === 5 }"></th>
                    <th :class="{ 'item-checked': true, highlight: selectedPackage === 6 }"></th>
                  </tr>
                  <tr>
                    <th>
                      <p>{{ packageDescriptionContent[6].primary_content }}</p>
                    </th>
                    <th :class="{ highlight: selectedPackage === 4 }"></th>
                    <th :class="{ highlight: selectedPackage === 5 }"></th>
                    <th :class="{ 'item-checked': true, highlight: selectedPackage === 6 }"></th>
                  </tr>
                  <tr>
                    <th></th>
                    <th>
                      <button @click="getSelectedPackageBeforeBilling(4)">blej</button>
                    </th>
                    <th>
                      <button @click="getSelectedPackageBeforeBilling(5)">blej</button>
                    </th>
                    <th>
                      <button @click="getSelectedPackageBeforeBilling(6)">blej</button>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="packages-mobile">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="tab-list">
              <ul class="nav form-list-2" role="tablist">
                <li>
                  <a
                    :class="{'nav-link-2': true, 'active show': offerPlanType==='annual'}"
                    aria-selected="true"
                    href="#tab-additional"
                    role="tab"
                    data-order="1"
                    data-toggle="tab"
                    id="tab_additional"
                    @click="getOfferPlanType('annual')"
                  >vjetore</a>
                </li>
                <li>
                  <a
                    href="#tab-payment"
                    role="tab"
                    data-order="2"
                    data-toggle="tab"
                    id="tab_payment"
                    @click="getOfferPlanType('seasonal')"
                  >sezonale</a>
                </li>
                <li></li>
              </ul>
            </div>
            <div class="tab-content" id="tab-2">
              <div
                role="tabpanel"
                :class="{ 'tab-pane': true, 'active show': offerPlanType==='annual'}"
                data-order="1"
                id="tab-additional"
              >
                <div class="tab tab-btn-2">
                  <button
                    :class="{ tablinks: true, active: selectedPackage === 4 || selectedPackage === 0 }"
                    @click="getSelectedPackage(4)"
                  >kosova</button>
                  <button
                    :class="{ tablinks: true, active: selectedPackage === 5 }"
                    @click="getSelectedPackage(5)"
                  >ballkani</button>
                  <button
                    :class="{ tablinks: true, active: selectedPackage === 6 }"
                    @click="getSelectedPackage(6)"
                  >evropa</button>
                </div>
                <div
                  v-if="selectedPackage === 4 || selectedPackage === 0"
                  id="kosova"
                  class="tabcontent tab-style"
                >
                  <ul>
                    <li :key="item" v-for="item in getPackageSecondaryDescriptionContent(4)">{{ item.trim()}}</li>
                  </ul>
                  <button @click="getSelectedPackageBeforeBilling(4)">blej</button>
                </div>
                <div v-if="selectedPackage === 5" id="region" class="tabcontent tab-style">
                  <ul>
                    <li :key="item" v-for="item in getPackageSecondaryDescriptionContent(5)">{{ item.trim()}}</li>
                  </ul>
                  <button @click="getSelectedPackageBeforeBilling(5)">blej</button>
                </div>
                <div v-if="selectedPackage === 6" id="europe" class="tabcontent tab-style">
                  <ul>
                    <li :key="item" v-for="item in getPackageSecondaryDescriptionContent(6)">{{ item.trim()}}</li>
                  </ul>
                  <button @click="getSelectedPackageBeforeBilling(6)">blej</button>
                </div>
              </div>
              <div
                  role="tabpanel"
                  class="tab-pane"
                  data-order="2"
                  id="tab-payment"
                  :class="{ 'tab-pane': true, 'active show': offerPlanType==='seasonal'}"
              >
                <div class="tab tab-btn-2">
                  <button
                    :class="{ tablinks: true, active: selectedPackage === 4 }"
                    @click="getSelectedPackage(4)"
                  >kosova</button>
                  <button
                    :class="{ tablinks: true, active: selectedPackage === 5 }"
                    @click="getSelectedPackage(5)"
                  >ballkani</button>
                </div>
                <div
                  v-if="selectedPackage === 4 || selectedPackage === 0 || selectedPackage === 6 || selectedPackage === 7"
                  id="seasonal_kosova"
                  class="tabcontent tab-style"
                >
                  <ul>
                    <li :key="item" v-for="item in getPackageSecondaryDescriptionContent(4)">{{ item.trim()}}</li>
                  </ul>
                  <button @click="getSelectedPackageBeforeBilling(4)">blej</button>
                </div>
                <div v-if="selectedPackage === 5" id="seasonal_region" class="tabcontent tab-style">
                  <ul>
                    <li :key="item" v-for="item in getPackageSecondaryDescriptionContent(5)">{{ item.trim()}}</li>
                  </ul>
                  <button @click="getSelectedPackageBeforeBilling(5)">blej</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="package-alert" style="margin-top: 7px;">
              <p>Nese zgjidhet oferta sezonale, perfshine mbulueshmerine ne rruge 24/7 per njeren nga pakot aktuale ne afat prej 60 ditesh</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { mapGetters } from "vuex";
import {packageDescriptionContent} from "../packageDescriptionContent";

import { calculatePackagePrice } from "../utils";

export default {
  name: "selectedOffer",

  components: {
    Header,
    Footer
  },
  data() {
    return {
      packageDescriptionContent: packageDescriptionContent
    }
  },
  computed: {
    ...mapGetters({
      offers: "subscriptions/offers",
      currentPromotion: "account/currentPromotion",
      offerPlanType: "selected/offerPlanType",
      selectedPackage: "selected/selectedPackage"
    }),
    getPackageSecondaryDescriptionContent() {
      return (offerId) => {
        const content = this.packageDescriptionContent[offerId];
        return content ? content.secondary_content.split('.').filter(item => item.trim()) : [];
      };
    },
  },
  async beforeMount() {
    await this.$store.dispatch("subscriptions/getOffers");
  },
  mounted() {
    this.$store.dispatch('selected/getCurrentReferralCode', this.$route.query.referral);
  },
  methods: {
    calculatePackagePrice,
    getOfferPlanType(value) {
      this.$store.dispatch("selected/getOfferPlanType", value);
    },
    getSelectedPackage(value) {
      this.$store.dispatch("selected/getSelectedPackage", { value: value });

    },
    getSelectedPackageBeforeBilling(value) {
      const payload = {
        router: this.$router,
        value: value
      };
      this.$store.dispatch("selected/getSelectedPackageBeforeBilling", payload);
    }
  }
};
</script>
